var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"container",on:{"click":function($event){return _vm.detail(index,item)}}},[_c('div',[_c('img',{attrs:{"src":item.img,"alt":""}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.name))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23030840","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/Panel/caozuoshouce/vidoe.vue
// module id = null
// module chunks = 